import { MenuItem } from './types'
import {
  URL_CLINICS,
  URL_PATIENTS,
  URL_RECEPTIVENESS,
  URL_SCRIPT,
  URL_USERS,
  URL_PGD_TEST, URL_PATIENTS_PGD,
  URL_IMMUNOCOM,
  URL_PGSEC_TEST,
  URL_PATIENTS_PGSEC,
  URL_PATIENTS_INMUNOCOM,
URL_KITS_DOWNLOAD,
  URL_IMPROVEMENTS,
} from '../../routes/routes-constants'
import {
  TITLE_CLINICS,
  TITLE_PATIENTS,
  TITLE_RECEPTIVENESS,
  TITLE_SCRIPT,
  TITLE_SETTINGS,
  TITLE_USERS,
  TITLE_TESTS,
  TITLE_PATIENTS_PGD,
  TITLE_PATIENTS_RECEPTIVENESS,
  TITLE_IMMUNOCOM,
  TITLE_PATIENTS_PGSEC,
  TITLE_PATIENTS_INMUNOCOM,
TITLE_KITS_DOWNLOAD,
  TITLE_IMPROVEMENTS
} from '../../routes/title-constants'
import { COLOR_MENU_PRIMARY } from '../../routes/color-constants'
import { getAuthContainer } from '../../container/auth-modules'
import { IAuthService } from '../../modules/auth/services/AuthService'
import { AUTH_SERVICE_KEY } from '../../modules/auth'
import { Permission } from '../../common/enums/Permissions'
import i18n from '../../i18n/i18n'

const authService = getAuthContainer().get<IAuthService>(AUTH_SERVICE_KEY)

export const sideBarMenuItems = (receptiveness: boolean, inmunocom: boolean, pgd : boolean, pgsec: boolean): MenuItem[] => {
  return [
    {
      name: TITLE_CLINICS,
      path: URL_CLINICS,
      image: '/icons/icon-clinics.svg',
      color: COLOR_MENU_PRIMARY,
      userAccess: authService.userCan(Permission.viewClinics),
    },
    {
      name: TITLE_PATIENTS,
      path: '',
      image: '/icons/icon-patients.svg',
      color: COLOR_MENU_PRIMARY,
      userAccess: true, 
      items: [
        {
          name: i18n.t(TITLE_PATIENTS_PGD),
          path: URL_PATIENTS_PGD,
          color: COLOR_MENU_PRIMARY,
          
          userAccess: pgd
        },
        {
          name: i18n.t(TITLE_PATIENTS_RECEPTIVENESS),
          path: URL_PATIENTS,
          color: COLOR_MENU_PRIMARY,
          userAccess: receptiveness 
        },
        {
          name: i18n.t(TITLE_PATIENTS_INMUNOCOM),
          path: URL_PATIENTS_INMUNOCOM,
          color: COLOR_MENU_PRIMARY,
          userAccess: inmunocom,  
        },
        {
          name: i18n.t(TITLE_PATIENTS_PGSEC),
          path: URL_PATIENTS_PGSEC,
          color: COLOR_MENU_PRIMARY,
          userAccess: pgsec,  
        }
      ],
    },

    {
      name: TITLE_TESTS,
      path: '',
      image: '/icons/icon-reports.svg', 
      color: COLOR_MENU_PRIMARY,
     
      userAccess: true,
      items: [
        {
          name: TITLE_PATIENTS_PGD,
          path: URL_PGD_TEST,
          color: COLOR_MENU_PRIMARY,
          userAccess: pgd
        },
        {
          name: i18n.t(TITLE_RECEPTIVENESS),
          path: URL_RECEPTIVENESS,
          color: COLOR_MENU_PRIMARY,
          userAccess: receptiveness
        },
        {
          name: i18n.t(TITLE_IMMUNOCOM),
          path: URL_IMMUNOCOM,
          color: COLOR_MENU_PRIMARY,
          userAccess: inmunocom
        },
        {
          name: TITLE_PATIENTS_PGSEC,
          path: URL_PGSEC_TEST,
          color: COLOR_MENU_PRIMARY,
          userAccess: pgsec
        },
      ],
    },
  
    {
      name: TITLE_SETTINGS,
      image: '/icons/icon-settings.svg',
      color: COLOR_MENU_PRIMARY,
      userAccess: true,
      items: [
        {
          name: TITLE_USERS,
          path: URL_USERS,
          userAccess: authService.userCan(Permission.editUsers),
        },
        {
          name: TITLE_SCRIPT,
          path: URL_SCRIPT,
          userAccess: authService.userCan(Permission.changeScript),
        },
        {
          name: TITLE_KITS_DOWNLOAD,
          path: URL_KITS_DOWNLOAD,
          userAccess: pgd || pgsec
          ,
        },
        {
          name: TITLE_IMPROVEMENTS,
          path: URL_IMPROVEMENTS,
          userAccess: true,
        },
      ],
    },
  ]
}
